import callAPI from '../ApiConfig'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

// Helper function to get auth params from cookies
const getAuthParams = () => {
    return {
        username: cookies.get('user_name'),
        user_id: cookies.get('user_id'),
        account_name: cookies.get('account_name'),
        account_id: cookies.get('account_id'),
        sid: cookies.get('sid'),
        baseurl: cookies.get('baseUrl'),
        id: cookies.get('id'),
    }
}

const mainAccounts = async (props) => {
    return await callAPI({
        route: "main_accounts/",
        method: "get",
        signal: props?.signal,
        params: {
            ...getAuthParams(),
            ...props?.params
        },
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const addMainAccount = async (props) => {
    return await callAPI({
        route: "main_accounts/",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: {
            ...getAuthParams(),
            ...props?.params
        },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })
}

const editMainAccount = async (props) => {
    return await callAPI({
        route: "main_accounts/" + props?.id,
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: {
            ...getAuthParams(),
            ...props?.params
        },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: 'application/json',
            ...props?.headers
        }
    })
}

const deleteMainAccount = async (props) => {
    return await callAPI({
        route: "main_accounts/" + props?.data?.id,
        method: "delete",
        signal: props?.signal,
        params: getAuthParams(),
        headers: {}
    })
}

const getMainAccountList = async (props) => {
    return await callAPI({
        route: "main_accounts/",
        method: "get",
        signal: props?.signal,
        params: {
            ...getAuthParams(),
            ...props?.params,
            show_list: 1
        },
        headers: {}
    })
}

const mainAccountAPI = {
    mainAccounts: mainAccounts,
    addMainAccount: addMainAccount,
    editMainAccount: editMainAccount,
    deleteMainAccount: deleteMainAccount,
    getMainAccountList: getMainAccountList,
}
export default mainAccountAPI
